<div class="tooltip" [innerHTML]="tooltipText()"></div>
